import React from "react";

const PaymentMethodPicker = ({ selected, onSelect }) => (
  <div className="PM-method-picker" role="tablist">
    <button
      type="button"
      className={`PM-method-tab ${selected === "card" ? "active" : ""}`}
      onClick={() => onSelect("card")}
    >
      Credit/Debit Card
    </button>
    <button
      type="button"
      className={`PM-method-tab ${selected === "etransfer" ? "active" : ""}`}
      onClick={() => onSelect("etransfer")}
    >
      Interac e-Transfer
    </button>
  </div>
);

export default PaymentMethodPicker;
